import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from 'vue';
    import { Icon, IconName } from '@travelata-libs/ui-kit';
    import { useViewport } from '@travelata-libs/utils';
    import ConfirmationTypeTooltip from './ConfirmationTypeTooltip.vue';
    import { ConfirmationType, ConfirmationTypeSize } from '../lib/types';
    import ConfirmationTypeModal from './ConfirmationTypeModal.vue';

    interface ConfirmationTypeIconProps {
        type?: ConfirmationType;
        size?: `${ConfirmationTypeSize}`,
        additionals?: boolean;
        background?: boolean,
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationTypeIcon',
  props: {
    type: { default: undefined },
    size: { default: ConfirmationTypeSize.L },
    additionals: { type: Boolean, default: true },
    background: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { type: ConfirmationType, size: `${ConfirmationTypeSize}`, additionals: boolean, background: boolean };

    

    const { isMobile } = useViewport();

    const iconName = computed(() => {
        if (!props.type) return '';

        const names: Record<ConfirmationType, IconName> = {
            [ConfirmationType.Cancel]: IconName.Wrong,
            [ConfirmationType.Long]: IconName.ClockFilled,
            [ConfirmationType.Quick]: IconName.BoltFilled,
        }
        return names[props.type] || '';
    });

    const additionalsComponent = computed(() => isMobile.value ? ConfirmationTypeModal : ConfirmationTypeTooltip);


return { __sfc: true,props, isMobile, iconName, additionalsComponent, Icon }
}

})